import BaseCollection from 'common/models/base/collection';
import collectionMixin from 'common/models/mixins/collection';
import TeamMember from './team-member';

export default BaseCollection.extend({
  apiEndpointAlias: 'teamMembers',

  /**
   */

  mixins: [collectionMixin],

  /**
   */

  createModel(properties) {
    properties.user = this.user;
    properties.notifier = this.notifier;
    return TeamMember.create(properties);
  },

  /**
   */

  loggedInUserCanModifyTeam() {
    // return !!this.filter(function(member) {
    //   return member.isLoggedInUser() && member.canModifyTeam();
    // }.bind(this)).length;

    return this.team.isOwner || this.team.isManager;
  },

  /**
   */
  getLoggedInUser() {
    return this.filter((member) => {
      return member.isLoggedInUser();
    })[0];
  },

  /**
   */
  loggedInUserIsDeveloper() {
    return !!this.filter((member) => {
      return member.isLoggedInUser() && member.isDeveloper();
    }).length;
  },

  /**
   */
  loggedInUserIsAdmin() {
    return this.team.isOwner;
  },

  /**
   */
  loggedInUserIsManager() {
    return !!this.filter((member) => {
      return member.isLoggedInUser() && member.isManager();
    }).length;
  },

  /**
   */

  addMember(properties) {
    return this.createModel(properties).save();
  },
});
